import React, { Component } from 'react';
import { Button, InputGroup, Input, InputGroupAddon, InputGroupText, FormText, FormGroup, Row, Col } from 'reactstrap';
import { Field, SubmissionError, reduxForm } from 'redux-form';
import { toast } from 'react-toastify';
import agent from '../../agent';
import { store } from '../../store';
import validation from '../../shared/common/validation.js';

import {
    FORGOTLOGIN_FORM_USERNAME_SUBMIT,
    FORGOTLOGIN_FORM_PASSWORD_SUBMIT,
} from '../../constants/actionTypes';

const validate = values => {
    const errors = {};
    return errors;
}

const mapStateToProps = state => ({
    ...state.ForgotLogin,
    appName: state.common.appName
});

const mapDispatchToProps = dispatch => ({
    onUsernameSubmit: (payload) =>
        dispatch({ type: FORGOTLOGIN_FORM_USERNAME_SUBMIT, payload }),
    onPasswordSubmit: (payload) =>
        dispatch({ type: FORGOTLOGIN_FORM_PASSWORD_SUBMIT, payload })
});

const renderField = ({ input, label, type, icon, meta: { asyncValidating, touched, error, warning } }) => (
    <FormGroup className="mb-3">
        <InputGroup>
            <InputGroupAddon addonType="prepend">
                <InputGroupText>
                    <i className={icon}></i>
                </InputGroupText>
            </InputGroupAddon>
            <Input {...input} type={type} placeholder={label}
                className={touched ? (error ? 'is-invalid' : null) : null} />
        </InputGroup>
        {touched && (error && <FormText color="danger">{error}</FormText>)}
    </FormGroup>
)

function submitUsername(values) {
    return agent.Authorization.sendusername(values.email)
        .then(response => {
            store.dispatch({ type: FORGOTLOGIN_FORM_USERNAME_SUBMIT, response });
            toast.success('Username sent successfully.');
        }).catch((error) => {
            if (error.response) {
                var errorList = {}
                for (var err in error.response.body.errors) {
                    errorList[err] = error.response.body.errors[err].message;
                }
                throw new SubmissionError(errorList);
            }
        });
}

function submitPassword(values) {
    return agent.Authorization.resetpassword(values.email)
        .then(response => {
            store.dispatch({ type: FORGOTLOGIN_FORM_USERNAME_SUBMIT, response });
            toast.success('Password Reset sent successfully.');
        }).catch((error) => {
            if (error.response) {
                var errorList = {}
                for (var err in error.response.body.errors) {
                    errorList[err] = error.response.body.errors[err].message;
                }
                throw new SubmissionError(errorList);
            }
        });
}

const asyncValidate = (values, dispatch, props, blurredField) => {
//    const previousErrors = props.asyncErrors;
    switch (blurredField) {
        default:
            break;
    }
    return new Promise(resolve => resolve());
}

class ForgotLoginForm extends Component {
    render() {
        const { handleSubmit, submitting, pristine } = this.props
        const req = validation.basic;
        return (
            <form>
                <Row>
                    <Col xs="12">
                        <Field component={renderField} icon="icon icon-envelope" type="text" label="Email" name="email" validate={[req.required, req.email]} />
                    </Col>
                </Row>

                <Row className="mb-3">
                    <Col xs="6">
                        <Button color="success" block onClick={handleSubmit(submitUsername)} disabled={pristine || submitting}>Send Username</Button>
                    </Col>
                    <Col xs="6">
                        <Button color="success" block onClick={handleSubmit(submitPassword)} disabled={pristine || submitting}>Reset Password</Button>
                    </Col>
                </Row>

                <Row>
                    <Col xs="12">
                        <Button color="secondary" block href="/" disabled={submitting}>Cancel</Button>
                    </Col>
                </Row>
            </form>
        );
    }
}

export default reduxForm({
    form: 'forgotLogin',
    validate,
    asyncValidate,
    asyncBlurFields: [],
    shouldAsyncValidate: ({ syncValidationPasses, trigger }) => {
        if (!syncValidationPasses) return false;
        return trigger !== 'submit';
    },
    mapStateToProps,
    mapDispatchToProps
})(ForgotLoginForm);


// WEBPACK FOOTER //
// ./src/containers/forms/ForgotLoginForm.js